import { $t } from '@/i18n'
import request from '@/utils/request'

// 店铺列表
export function shopList(params) {
  return request({
    url: '/shop/v1',
    params
  })
}

// 店铺批量启用禁用
export function shopBatchEnabled(data) {
  return request(
    {
      url: '/shop/batch/enabled/v1',
      method: 'PUT',
      data
    }
  )
}

//新增列表
export function addShop(data) {
  return request({
    url: '/shop/v1',
    method: 'POST',
    data
  })
}

//绑定、换绑
export function editShop(id, data) {
  return request({
    url: `/shop/${ id }/v1`,
    method: 'PUT',
    data
  })
}

// 店铺详情
export function getShop(id) {
  return request({
    url: `/shop/${ id }/v1`
  })
}

// 店铺模版详情
export function getShopTemplate(id) {
  return request({
    url: `/shop/template/${ id }/v1`
  })
}

// 店铺设备信息查询
export function shopDeviceDetail(id) {
  return request({
    url: `/shop/device/${ id }/v1`
  })
}

// 温度曲线
export function getCabinetTemperatureCurve(shopId, params) {
  return request({
    url: `/shop/temperature_curve/${ shopId }/v1`,
    params
  })
}

// 网络状态曲线
export function getNetworkStatusCurve(id, params) {
  return request({
    url: `/shop/network_status_curve/${ id }/v1`,
    params
  })
}

// 商品模板更新
export function shopTemplateAddEdit(id, data) {
  return request({
    url: `/shop/template/${ id }/v1`,
    method: 'PUT',
    data
  })
}

// 添加商品时 获取的价格
export function getPrice(shopId, goodsCode) {
  return request({
    url: `/shop/template/${ shopId }/${ goodsCode }/v1`
  })
}

// 会员类别列表
export function vipList(params) {
  return request({
    url: `/mct_user_tag/v1`,
    params
  })
}

// 店铺配置修改
export function shopConfig(id, data) {
  return request(
    {
      url: `/shop/config/${ id }/v1`,
      method: 'POST',
      data
    },
    {
      success: true,
      successMsg: $t('storeModules.store.configurationSuccess')
    }
  )
}

// 货柜批量调节声音
export function volumeAdjustmentApi(data) {
  return request(
    {
      url: `/shop/batch/volume/v1`,
      method: 'PUT',
      data
    },
    {
      success: true,
      successMsg: $t('common.operatorOK')
    }
  )
}

// 批量修改店铺配置
export function batchUpdateShopConfig(data) {
  return request(
    {
      url: '/shop/config/v1',
      method: 'POST',
      data
    },
    {
      success: true,
      successMsg: $t('storeModules.store.settingsSuccess')
    }
  )
}

// 根据货柜编码查询同型号的店铺信息
export function sameModelShopDetail(cabinetCode, params) {
  return request({
    url: `/shop/type/${ cabinetCode }/v1`,
    params
  })
}

// 店铺模板同步
export function synchronizationShopModal(id, data) {
  return request(
    {
      url: `/shop/template/${ id }/v1`,
      method: 'POST',
      data
    },
    {
      success: true,
      successMsg: $t('common.operatorOK')
    }
  )
}

// 重启
export function shopReboot(id) {
  return request(
    {
      url: `/shop/reboot/${ id }/v1`,
      method: 'PUT'
    },
    {
      success: true,
      successMsg: $t('storeModules.store.deviceRestartTips')
    }
  )
}

// 货柜批量锁柜
export function batchAutoEnabled(data) {
  return request({
    url: '/shop/batch/auto_enabled/v1',
    method: 'PUT',
    data
  }, {
    success: true,
    successMsg: $t('storeModules.store.batchSettingsSuccess')
  })
}

//获取场景列表
export function getSceneList(params) {
  return request({
    url: '/scene_info/large/v1',
    params
  })
}

//获取场景列表
export function getState(params) {
  return request({
    url: '/usInfo/v1',
    params
  })
}




// 判断通用模板/店铺模板当中是否有禁用商品
export function judgmentCheckGoods(params) {
  return request({
    url: '/goods_tmpl/check_goods_status/v1',
    params
  })
}

// 店铺模板添加货道
export function addShopSlot(shopId, data) {
  return request(
    {
      url: `/shop/template/${shopId}/slot/v2`,
      method: 'POST',
      data,
    },
    {
      success: true,
      successMsg: $t('constant.addSuccess'),
    }
  )
}

// 店铺模板删除扩展货道
export function deleteShopSlot(shopId, data) {
  return request(
    {
      url: `/shop/template/${shopId}/slot/v2`,
      method: 'DELETE',
      data,
    },
    {
      success: true,
      successMsg: $t('constant.deletedSuccessfully'),
    }
  )
}

// 一键开门
export function unlockDoor(cabinetCode, data) {
  return request(
    {
      url: `/mct_device_cabinet/${cabinetCode}/unlock_door/v1`,
      method: 'POST',
      data
    },
    {
      success: true,
      successMsg: $t('storeModules.store.openDoorSuccess')
    }
  )
}

// 设备自检
export function selfCheck(cabinetCode) {
  return request(
    {
      url: `/mct_device_cabinet/${cabinetCode}/self_check/v1`,
      method: 'POST'
    },
    {
      success: true,
      successMsg: $t('storeModules.store.selfCheckSuccess')
    }
  )
}

// 开始设备自检
export function startSelfCheck(cabinetCode) {
  return request({
    url: `/mct_device_cabinet/${cabinetCode}/self_check/v1`,
    method: 'POST'
  })
}

// 获取设备自检结果（轮询场景，失败静默处理不弹提示）
export function getSelfCheckResult(cabinetCode, checkId) {
  return request(
    {
      url: `/mct_device_cabinet/self_check_result/${cabinetCode}/${checkId}/v1`,
      method: 'GET'
    },
    {
      error: false
    }
  )
}

// 根据货柜编号查询 POS 厂商类型
export function getPosVendorType(cabinetCode) {
  return request({
    url: `/mct_device_cabinet/pos_vendor_type/${cabinetCode}/v1`,
    method: 'GET'
  })
}

// 智能柜强制开启制冷提醒校验
export function getCoolingReminder(shopId) {
  return request({
    url: '/shop/reminder/v1',
    params: {
      type: 1,
      shop_id: shopId
    }
  })
}

// 停机保护中强制开启制冷
export function flushDeviceCooling(cabinetCode) {
  return request({
    url: `/mct_device_cabinet/flush/${cabinetCode}/v1`,
    method: 'GET'
  })
}

// 获取智能柜语言选项
export function getLanguageOptions() {
  return request({
    url: '/shop/language/options/v1',
    method: 'GET'
  })
}

// 获取 POS 激活邮箱
export function getRootEmail() {
  return request({
    url: '/worker/root_email/v1',
    method: 'GET'
  })
}

// 申请 POS 激活/关闭激活
export function applyPosActivation(data) {
  return request({
    url: '/shop/pos_activation/apply/v1',
    method: 'POST',
    data
  })
}

// 一键同步-获取同步信息
export function getShopSyncInfo() {
  return request({
    url: '/shop/sync_info/v1',
    method: 'GET'
  })
}

// 一键同步-执行同步
export function oneClickSync(data) {
  return request({
    url: '/shop/one_click_sync/v1',
    method: 'POST',
    data
  })
}

// 一键同步-待支付检查
export function pendingPayCheck(data) {
  return request({
    url: '/shop/one_click_sync/pending_pay_check/v1',
    method: 'POST',
    data
  })
}

// 删除店铺
export function deleteShop(id) {
  return request({
    url: `/shop/${id}/v1`,
    method: 'DELETE'
  })
}


